import { useEffect, useState } from "react";
import { ChosenEntityToRelate, RelationSaveModel } from "../../../../taskManagement/createTaskPane/CreateTaskPane.types.ts";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { INoteDialogProps } from "./DotLegalNoteDialog.tsx";
import { put } from "../../../api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useDotLegalNoteDialogHook(props: INoteDialogProps) {
    const [note, setNote] = useState(props.noteText ?? "");
    const [relations, setRelations] = useState<Array<ChosenEntityToRelate>>([]);

    useEffect(() => {
        if (props.noteText) {
            setNote(props.noteText);
        }
    }, [props.noteText]);

    const { translateString } = useTranslation();

    const snackbar = useDotLegalSnackbar();

    const saveNoteMutation = useDotLegalMutation(updateNote);

    const onSaveClick = () => {
        saveNoteMutation.mutateAsync(
            { note: note, relations: relations },
            {
                onSuccess: (resp: any) => {
                    snackbar.show(translateString("noteUpdated"), "success");
                    props.onNoteUpdated();
                },
            }
        );
    };

    function updateNote(data: { note: string; relations: Array<ChosenEntityToRelate> }) {
        return put<{}>(props.postUrl!, {
            note: note,
            relations: relations.map((x) => {
                return {
                    fromEntityType: props.entityType,
                    fromEntityId: props.entityId,
                    toEntityId: x.entityId,
                    toEntityType: x.entityType,
                };
            }),
        });
    }

    return {
        note,
        setNote,
        relations,
        setRelations,
        onSaveClick,
        isSaving: saveNoteMutation.isLoading,
    };
}
